import React, { FC, useState } from "react";
import JumboFormRawMaterial from "../../popups/JumboFormRawMaterial/JumboFormRawMaterial";
import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import { Span } from "../Text/Text";
import Tooltip from "../Tooltip/Tooltip";
import RawMaterialRow from "./components/RawMaterialRow";
import { RawMaterialT } from "../../models/models";
import { useAppSelector } from "../../store/hooks";
import { selectCurrentUser } from "../../store/selectors/authSelectors";
import { UserRoleE } from "../../models/enums";
import { isMobileOrTablet } from "../../utils/helpers/mediaQueries";

import styles from "./styles.module.scss";

type UploadRawMaterialsPropTypes = {
  rawMaterials: RawMaterialT[];
  campaignNumber: number;
  deliveryNumber: number;
  campaignName: string;
  deliveryName: string;
  broadcastingDate: string;
  postProductionCompanyName: string;
  projectId: number;
  JumboForm_EN: string;
  JumboForm_HE: string;
};

const UploadRawMaterials: FC<UploadRawMaterialsPropTypes> = (props) => {
  const {
    rawMaterials,
    campaignNumber,
    deliveryName,
    projectId,
    campaignName,
    broadcastingDate,
    postProductionCompanyName,
    JumboForm_EN,
    JumboForm_HE,
    deliveryNumber,
  } = props;
  const [showJumboForm, setShowJumboForm] = useState(false);
  const user = useAppSelector(selectCurrentUser);
  const tooltipText =
    "This delivery includes a version required for content adaptation. In addition to the version's MXF file, please upload all required raw material files.";
  const [showTooltip, setShowTooltip] = useState(false);

  const handleUpload = () => {
    setShowJumboForm(true);
  };

  const handleShowTooltip = () => {
    if (isMobileOrTablet()) {
      setShowTooltip((prev) => !prev);
    }
  };

  return user?.role === UserRoleE.PostProduction ||
    user?.role === UserRoleE.DeliveryService ||
    user?.role === UserRoleE.AdvertisingAgency ||
    (user?.role === UserRoleE.GlobalAdmin ? !!rawMaterials?.length : false) ||
    !!rawMaterials?.length ? (
    <>
      <div className={styles.wrapper}>
        {user?.role === UserRoleE.PostProduction ||
        user?.role === UserRoleE.DeliveryService ||
        user?.role === UserRoleE.AdvertisingAgency ? (
          <div className={styles.header}>
            <Span className={styles.title}>
              Upload raw materials for version adaptation
            </Span>
            {
              <Tooltip text={!isMobileOrTablet() && tooltipText}>
                <div className={styles.infoIcon}>
                  <Icon name="info" onClick={handleShowTooltip} />
                  {showTooltip && (
                    <Span
                      className={styles.mobileTooltip}
                      onClick={handleShowTooltip}
                    >
                      {tooltipText}
                    </Span>
                  )}
                </div>
              </Tooltip>
            }
            <Button onClick={handleUpload} className={styles.uploadButton}>
              Upload raw
            </Button>
          </div>
        ) : (
          <div className={styles.header}>
            <Span className={styles.title}>Raw materials</Span>
          </div>
        )}
        {!!rawMaterials?.length && (
          <ul className={styles.rawList}>
            {rawMaterials.map((data, index) => (
              <RawMaterialRow data={data} key={data.ID} index={index} />
            ))}
          </ul>
        )}
      </div>
      {showJumboForm && (
        <JumboFormRawMaterial
          onClose={setShowJumboForm}
          campaignNumber={campaignNumber}
          campaignName={campaignName}
          deliveryName={deliveryName}
          deliveryNumber={deliveryNumber}
          projectId={projectId}
          broadcastingDate={broadcastingDate}
          postProductionCompanyName={postProductionCompanyName}
          JumboForm_EN={JumboForm_EN}
          JumboForm_HE={JumboForm_HE}
        />
      )}
    </>
  ) : (
    <></>
  );
};

export default UploadRawMaterials;
